import React, { memo, useState, useEffect } from 'react';

function PowerUpDepletedPrompt({ powerUpType, sessionNumber, onWatchAd, onBuyPack, onGoPremium, onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const typeLabel = powerUpType === 'undo' ? 'Undos' : powerUpType === 'bomb' ? 'Bombs' : 'Refreshes';
  const canWatchAd = sessionNumber >= 4;

  return (
    <div className={`game-over-overlay${visible ? ' game-over-visible' : ''}`} role="dialog" aria-label={`No ${typeLabel} remaining`}>
      <div className="depleted-prompt-card">
        <h3 className="depleted-prompt-title">No {typeLabel} Left</h3>
        <p className="depleted-prompt-text">
          Get more {typeLabel.toLowerCase()} to keep your streak going.
        </p>

        <div className="depleted-prompt-options">
          {canWatchAd && (
            <button className="depleted-option depleted-option-ad" onClick={onWatchAd}>
              <span className="depleted-option-icon">&#9654;</span>
              <span className="depleted-option-text">
                <span className="depleted-option-label">Watch Ad</span>
                <span className="depleted-option-desc">Get 1 free</span>
              </span>
            </button>
          )}

          <button className="depleted-option depleted-option-buy" onClick={onBuyPack}>
            <span className="depleted-option-icon">&#128176;</span>
            <span className="depleted-option-text">
              <span className="depleted-option-label">Buy Pack</span>
              <span className="depleted-option-desc">From $0.99</span>
            </span>
          </button>

          <button className="depleted-option depleted-option-premium" onClick={onGoPremium}>
            <span className="depleted-option-icon">&#9733;</span>
            <span className="depleted-option-text">
              <span className="depleted-option-label">Go Premium</span>
              <span className="depleted-option-desc">Daily free power-ups</span>
            </span>
          </button>
        </div>

        <button className="depleted-prompt-dismiss" onClick={onDismiss}>
          Maybe Later
        </button>
      </div>
    </div>
  );
}

export default memo(PowerUpDepletedPrompt);
